import React from "react"
import { Button } from "@/components/Button"

import { ConfirmButtonProps } from "@/components/Dialog/protocols"

export const ConfirmButton = (props: ConfirmButtonProps) => {
	return (
		<Button.Primary
			onClick={props.onClick}
			size={props.size || "medium"}
			disabled={props.disabled}
			startIcon={props.startIcon}
		>
			{props.children}
		</Button.Primary>
	)
}
